import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@xilo-mono/common/config';

/** TODO: new project.json
 * Ensure that all folder names in S3 are company.companyId,
 * and NOT company.id
 */

export interface SEOPayload {
  message: 'fail'|'success';
  data: SEO;
}

export interface SEO {
  title?:string, fav_icon?:string, loader_icon?:string
}

@Injectable()
export class SEOService {
  apiUrl = this.configService.apiUrl + '/seo';

  constructor(private http: HttpClient, private configService: ConfigService) {}

  /**
   * Get SEO metadata by company.companyId, NOT by primary key
   *
   * Intentionally written to fail silently, even if the call to S3 fails.
   * If this were to fail in the resolver, the Angular would send the user
   * to the fallback route, which is not what we want.
   * @param companyId
   */
  getSEOMetadata(companyId: number): Observable<SEOPayload> {
    return this.http.get<SEOPayload>(`${this.apiUrl}/company/${companyId}`);
  }

}
